import { render, staticRenderFns } from "./JTooltip.vue?vue&type=template&id=6d88d93a&scoped=true&"
import script from "./JTooltip.vue?vue&type=script&lang=js&"
export * from "./JTooltip.vue?vue&type=script&lang=js&"
import style0 from "./JTooltip.vue?vue&type=style&index=0&id=6d88d93a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88d93a",
  null
  
)

export default component.exports